import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { selectLogInUsername } from "../../../../common/authenticateDashboard/authSlice";
import { LoadingAnimation } from "../../../../components/Loading/LoadingAnimation";
import { VisitorsNumbersByContentGraph } from "../../../../components/Graphs/graphs";
import {
    SelectUTMContentStatus,
  SelectVisitors,
  SelectPercentBooking,
  SelectPercentBought,
  SelectWeeks,
  SelectLabels,
  graphUTMContent,
} from "./utmContentSlice";
import { SingleGraphLoading } from "../../../../components/Skeletons";

const UTMContent = ({ display }) => {
  const dispatch = useDispatch();
  const sessionUser = useSelector(selectLogInUsername);
  const user = sessionUser?.split("@")[0];

//   const UTMContentData = useSelector((state) => state.utmContent);
  const loading = useSelector(SelectUTMContentStatus);
  const weeks = useSelector(SelectWeeks);
  const visitors = useSelector(SelectVisitors);
  const percentBooking = useSelector(SelectPercentBooking);
  const percentBought = useSelector(SelectPercentBought);
  const adsLabels = useSelector(SelectLabels);

  useEffect(() => {
    if (!user) return null;
    if(weeks.length===0) dispatch(graphUTMContent(user));
  }, [user, weeks]);


    
  if (loading === "loading") return <SingleGraphLoading />;
  return (
    <VisitorsNumbersByContentGraph
      loading={loading === "loading"}
      display={display}
      weeks={weeks}
      visitors={visitors}
      percentOfBooking={percentBooking}
      nameLabels={adsLabels}
      totalSales={percentBought}
    />
  );
};

export default UTMContent;